import React, { useContext } from "react";
import styled from "styled-components";
import Switch from "../Components/Switch";
import AppContext from "../Contexts/AppContext";
import Flex from "../Components/Flex";
import { lightTheme, darkTheme } from "../Shared/theme";

const Profile: React.FC = () => {
  const { appState, setDarkMode } = useContext(AppContext);

  const handleToggleTheme = (isChecked: boolean) => {
    // TODO: need to load the user settings at the startup for app impact settings like theme,'meta[name="theme-color"], etc.
    setDarkMode(isChecked);

    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) themeColorMeta.setAttribute("content", isChecked ? darkTheme.backgroundColor : lightTheme.backgroundColor);

    const msTileColor = document.querySelector('meta[name="msapplication-TileColor"]');
    if (msTileColor) msTileColor.setAttribute("content", isChecked ? darkTheme.backgroundColor : lightTheme.backgroundColor);
  };

  return (
    <>
      <Flex $justify="space-between">
        <Title>Dark mode</Title>
        <Switch onToggle={handleToggleTheme} initValue={appState.theme.isDark} />
      </Flex>
    </>
  );
};

const Title = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.buttonTextColor};
`;

export default Profile;
